import { RefObject, useEffect, useRef } from 'react'

type Props = {
  onLoadMore: () => void
  rootRef?: RefObject<HTMLElement | null>
}

const LoadMoreObserver = ({ onLoadMore, rootRef }: Props) => {
  const onLoadMoreRef = useRef(onLoadMore)
  onLoadMoreRef.current = onLoadMore

  const ref = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!ref.current || !rootRef?.current) return
    const observer = new IntersectionObserver(
      entries => {
        if (!entries?.[0]?.isIntersecting) return
        onLoadMoreRef.current()
      },
      { root: rootRef.current, rootMargin: '50px' }
    )
    observer.observe(ref.current)
    return () => observer.disconnect()
  }, [rootRef])

  return <div ref={ref} style={{ height: 1 }} />
}

export default LoadMoreObserver
